import { Box, Typography, styled } from '@mui/material';
import { fontFamily } from 'theme/overrides/fontFamily';

export const TextPromptContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(4),
  paddingTop: theme.spacing(2),
  paddingRight: theme.spacing(2),
  gap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    flexDirection: 'column',
    alignItems: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
  },
}));

export const ImageBox = styled('img')(({ theme }) => ({
  width: theme.spacing(22.5),
  aspectRatio: '1 / 1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(17),
  },
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'center',
  },
}));

export const ResultsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontSize: 'clamp(16px, 1.3vw, 24px)',
  color: theme.palette.grey[50],
  fontWeight: 500,
  fontFamily: fontFamily.drukWideMedium,
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    width: theme.spacing(20),
  },
}));

export const PromptText = styled(Typography)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  fontSize: 12,
  color: theme.palette.grey[300],
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));
